import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';

function shouldShowCampaigns() {
  return GrowthDiscoveryExperiments.get('enableSelfServeCampaigns');
}

export default shouldShowCampaigns;
